import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, VoiceAIOutreach } from "@/types";

export function useGetVoiceAIOutreaches({
  currentCandidacyId,
  enabled = true,
}: {
  currentCandidacyId: string;
  enabled?: boolean;
}) {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  return useQuery({
    queryKey: [
      "voice-ai-outreaches",
      currentCompanyId,
      currentJobId,
      currentCandidacyId,
    ],
    enabled,
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/${currentCandidacyId}/voice-ai-outreaches`;
      const res = await guacHttpClient.get<
        VoiceAIOutreach[],
        HttpResponse<VoiceAIOutreach[]>
      >(path);
      return res.data;
    },
  });
}
